import React, { useState, useRef, useEffect, useContext } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import PropTypes from 'prop-types';
import { Calendar, CalendarCell, CalendarHeaderTitle, CalendarViewEnum } from '@progress/kendo-react-dateinputs';
import { IntlProvider, LocalizationProvider } from "@progress/kendo-react-intl";
import IconButton from '@material-ui/core/IconButton';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from '@material-ui/core';
import { faArrowsRotate } from "@fortawesome/pro-duotone-svg-icons";
import { faLoader } from "@fortawesome/pro-duotone-svg-icons";
import { withNamespaces } from 'react-i18next'
import { MessageContext } from '@/MessageProvider';
import { SvgIcon } from '@progress/kendo-react-common';
import * as svgIcons from '@progress/kendo-svg-icons';
import { makeStyles } from '@material-ui/core/styles';
import moment from "moment";
import i18next from 'i18next';
import * as storage from '@utils/storage';
import * as pageSourceCode from '@scripts/PageSourceCode';
import { gettApprovalRequestCalendar } from '@actionsSup/approvalCentral';
import { messagesTypes } from '@utils/constants';
import { approvalType } from '@scripts/CentralApprovalTypeHelper';
import { centralApprovalStatus, getCentralApprovalStatusDescription } from '@scripts/CentralApprovalStatusHelper';
import { approveRequest, denyRequest } from '@actionsSup/approvalCentral';
import { absenceCalendarStatus, getAbsenceCalendarStatusDescription } from '@scripts/AbsenceCalendarStatusHelper';
import { cancellableStatus, getCentralApprovalCancellableStatusDescription } from '@scripts/CentralApprovalCancellableStatusHelper';
import { getDayAbbrUpper, getMonth, getMonthAbbrUpper, capitalizeFirstLetter } from '@/utils';
import { saveLeaveApprovalCentralRequest } from '@actionsSup/approvalCentral';
import { IsEnglish } from '@/utils/language';
import { GetLanguage } from '@utils/language';
import { isIOS } from '@utils/index';
import { format, formatDate, isNullOrEmpty } from '@utils';
import "@progress/kendo-theme-default/dist/all.css";
import styles from '@styles/approvalCentral.module.css';
import RequestDetail from './RequestDetail';
import ScheduleGenerationForm from './ScheduleGenerationForm';
import LegendTypeDay from './LegendTypeDay';

moment.locale("fr");

const useStyles = makeStyles((theme) => ({
    selectMonth: {
        paddingLeft: '27px',
        backgroundColor: '#5c7fb9',
        color: '#ffffff',
        border: '2px solid #ffffff',
        borderRadius: '10px',
        marginTop: '5px',
        textAlign: 'center'
    },
    refreshButton: {
        position: 'relative',
        right: '-45px'
    },
    divLegend: {
        bottom: '79px',
        position: 'fixed',
        justifySelf: 'center'
    }
}));

function CalendarItems(props) {

    const {
        filter
    } = props;

    const isiOS = isIOS();

    const classes = useStyles();
    const calendarRef = useRef(null);
    const isFromNavigationBtnRef = useRef(false);
    const currentDateRef = useRef(new Date());
    const { dispatch } = useContext(MessageContext);

    const [locale, setLocale] = useState('fr');
    const [date, setDate] = useState(new Date());
    const [month, setMonth] = useState((new Date()).getMonth());
    const [isFirstLoad, setIsFirstLoad] = React.useState(true);

    const [data, setData] = useState(null);
    const [filteredData, setFilteredData] = useState(null);
    const [dataRow, setDataRow] = useState(null);
    const [open, setOpen] = useState(false);
    const [isActive, setIsActive] = useState(true);

    const [actionTypeCode, setActionTypeCode] = useState(null);
    const [comment, setComment] = useState('');
    const [openScheduleGeneration, setOpenScheduleGeneration] = useState(null);
    const [isConfirm, setIsConfirm] = useState(false);
    const [openConfirm, setOpenConfirm] = useState(false);
    const [messageConfirm, setMessageConfirm] = useState(null);
    const [isPosting, setIsPosting] = useState(false);
    const [isCancellable, setIsCancellable] = useState(false);
    const [isLeaveRequest, setIsLeaveRequest] = useState(false);
    const [isDenyButtonEnabled, setIsDenyButtonEnabled] = useState(false);
    const [isApproveButtonEnabled, setIsApproveButtonEnabled] = useState(false);

    const monthNames = IsEnglish() ?
        ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"] :
        ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"];

    const actionType = {
        DENY: 'R',
        APPROVE: 'F'
    }

    useEffect(() => {
        const language = GetLanguage();
        moment.locale(language);
        setLocale(language);
        resizeForm();
    }, []);

    useEffect(() => {
        refreshCalendar();
    }, [filter]);

    useEffect(() => {
        if (!isFirstLoad) {
            refreshCalendar();
        }        
    }, [month]);

    useEffect(() => {
        if (actionTypeCode) {
            switch (actionTypeCode) {
                case actionType.APPROVE:
                    {
                        handleApproveRequest();
                        break;
                    }
                case actionType.DENY:
                    {
                        handleDenyRequest();
                        break;
                    }
            }
        }
    }, [actionTypeCode])

    useEffect(() => {
        if (openScheduleGeneration === false) {
            handleCloseConfirm();
        }
    }, [openScheduleGeneration])

    const resizeForm = () => {

        if (props.resizeForm != undefined && props.resizeForm != null) {
            props.resizeForm();
            return;
        }

        setTimeout(function () {

            const offSet = 114;
            const height = window.innerHeight;
            const titleBar = document.querySelector('#appBarTitle').clientHeight;
            const header = document.querySelector('div[data-id=headerRequest]').offsetHeight;
            const customHeight = height - header - titleBar - offSet;
            const element = document.querySelector('#divListRequest');
            const divFilterRequest = document.querySelector('#divFilterRequest');
            const requestCalendar = document.querySelector('#requestCalendar');
            const requestHeader = document.querySelector('#requestHeader');
            const requestDetail = document.querySelector('#requestDetail');
            const legend = document.querySelector('#divLegend').clientHeight;

            if (element !== null) {
                element.style.height = `${customHeight}px`;
                element.style.overflowX = 'hidden';
            }
            
            if (requestHeader && requestDetail && requestCalendar) {
                const divFilterRequestHeight = divFilterRequest.offsetHeight;
                const requestCalendarHeight = requestCalendar.offsetHeight;
                const requestHeaderHeight = requestHeader.offsetHeight;
                const detailHeight = customHeight - requestCalendarHeight - requestHeaderHeight - divFilterRequestHeight - legend - 50;
                requestDetail.style.height = `${detailHeight}px`;
                requestDetail.style.overflowY = 'overlay';
            }

        }, 0);
    }

    const refreshCalendar = async () => {

        if (isFirstLoad) {
            setIsFirstLoad(false);
        }
        
        if (filter != null
            && filter.typeRequest !== undefined
            && filter.typeRequest !== null) {
            await loadData();
            isFromNavigationBtnRef.current = false;
        }        
    }

    const loadData = async() => {

        setIsActive(true);
        let typeRequest = filter.typeRequest;
        let status = filter.status;

        // default
        if (typeRequest === undefined || typeRequest === null) {
            typeRequest = [approvalType.LEAVE, approvalType.LEAVE_AZUR, approvalType.VACATION, approvalType.VACATION_AZUR];
        }

        if (status === undefined || status === null) {
            status = [absenceCalendarStatus.PENDING, absenceCalendarStatus.APPROVED, absenceCalendarStatus.REFUSED];
        }

        if (typeRequest.length === 0 || status.length === 0) {
            setData(null);
            setIsActive(false);
            return;
        }

        const result = await gettApprovalRequestCalendar(status.join('|'), typeRequest.join('|'), '%', date.getMonth() + 1, date.getFullYear());        

        if (result !== undefined) {
            let list = await formatList(result);
            setData(list);
            const currentDate = new Date(date.toLocaleDateString('en-US'));
            setFilteredData(list?.filter(x => currentDate >= new Date(x.startDate) && (currentDate <= new Date(x.endDate) || x.endDate === null)));
        } else {
            dispatch({ type: messagesTypes.GENERICERROR });
        }

        setIsActive(false);
    }

    const formatList = async (data) => {
        return new Promise(async (resolve) => {
            const list = [];
            data.forEach((item) => {
                item.statusDescription = getAbsenceCalendarStatusDescription(item.statusCode);
                list.push(item);
            });

            resolve(list);
        })
    }

    const getIsCancellable = (obj) => {
        return obj.cancellableCode == cancellableStatus.CANCELLABLE;
    }

    const getIsApproveButtonEnabled = (obj) => {
        return obj.statusCode == centralApprovalStatus.OPENED || obj.statusCode == centralApprovalStatus.CANCEL_REQUEST;
    }

    const getIsActionButtonShown = (obj) => {
        //return obj.statusCode == centralApprovalStatus.OPENED || obj.statusCode == centralApprovalStatus.CANCEL_REQUEST || obj.statusCode == centralApprovalStatus.CALENDAR_REQUEST;
        return true;
    }

    const getIsDenyButtonEnabled = (obj) => {
        return obj.statusCode == centralApprovalStatus.CLOSE ?
            getIsCancellable(obj) :
            obj.statusCode != centralApprovalStatus.CANCELED;
    }

    const getIsLeaveRequest = (obj) => {
        return (obj.approvalType === approvalType.LEAVE
            || obj.approvalType === approvalType.LEAVE_AZUR
            || obj.approvalType === approvalType.VACATION
            || obj.approvalType === approvalType.VACATION_AZUR)
            && (getIsApproveButtonEnabled(obj) || getIsDenyButtonEnabled(obj))
            && obj.statusCode == centralApprovalStatus.OPENED
            && isNullOrEmpty(obj.approverComment);
    }

    const updateAction = async () => {
        if (actionTypeCode) {
            switch (actionTypeCode) {
                case actionType.APPROVE:
                    {
                        updateApproveRequest();
                        break;
                    }
                case actionType.DENY:
                    {
                        updateDenyRequest();
                        break;
                    }
            }
        }
    }

    const approve = async (updateComment = false) => {

        setIsPosting(true);

        const result = await approveRequest(dataRow.centralApprovalId);

        if (result === undefined) {
            dispatch({ type: messagesTypes.GENERICERROR });
            setIsPosting(false);
            return;
        } else if (result.statusCode === 0) {

            dispatch({ type: messagesTypes.SUCCESS, payload: i18next.t('approvalCentral:message.updateSuccess') });

            if (updateComment && !saveComment(false)) {
                loadData();
                return;
            }

        } else if (result.statusCode === 1) {

            dispatch({ type: messagesTypes.WARNING, payload: result.message });

            if (updateComment && !saveComment(false)) {
                loadData();
                return;
            }

        } else if (result.statusCode === -2) {
            setIsPosting(false);
            setOpenScheduleGeneration(true);
            return;
        }

        handleCloseConfirm();
        loadData();
    }

    const updateApproveRequest = async () => {
        approve(open);
    }

    const deny = async (updateComment = false) => {

        setIsPosting(true);

        const result = await denyRequest(dataRow.centralApprovalId, dataRow.approvalTypeCode, comment);

        if (result === undefined) {
            dispatch({ type: messagesTypes.GENERICERROR });
            setIsPosting(false);
            return;
        } else if (result.statusCode === 0) {

            let messsge = i18next.t('approvalCentral:message.refusedSucess');

            if (!isLeaveRequest
                && dataRow.statusCode == centralApprovalStatus.CLOSE) {
                messsge = i18next.t('approvalCentral:message.canceledSuccess');
            }

            dispatch({ type: messagesTypes.SUCCESS, payload: messsge });

            if (updateComment && !saveComment(false)) {
                loadData();
                return;
            }

        } else if (result.statusCode === 1) {

            dispatch({ type: messagesTypes.CUSTOMERROR, payload: result.message ?? i18next.t('approvalCentral:message.deleteError') });

            if (updateComment && !saveComment(false)) {
                loadData();
                return;
            }

        } else if (result.statusCode === -2) {
            setIsPosting(false);
            setOpenScheduleGeneration(true);
            return;
        }

        handleCloseConfirm();        
        loadData();
    }

    const saveComment = async (showMessage = true) => {

        const result = await saveLeaveApprovalCentralRequest(dataRow.originTableNameId, dataRow.isToReplace, comment);

        if (result === undefined) {
            dispatch({ type: messagesTypes.GENERICERROR });
            setIsPosting(false);
            return false;
        } else if (result.statusCode === 0) {
            if (showMessage === true) {
                dispatch({ type: messagesTypes.SUCCESS, payload: i18next.t('approvalCentral:message.updateSuccess') });
            }            
            return true;
        } else if (result.statusCode === -1) {
            dispatch({ type: messagesTypes.CUSTOMERROR, payload: result.message });
            setIsPosting(false);
            return false;
        }
    }

    const updateDenyRequest = async () => {
        deny(open);
    }

    const handleApproveRequest = () => {
        if (isApproveButtonEnabled) {
            if (isCancellable) {
                if (isNullOrEmpty(messageConfirm)) {
                    updateApproveRequest();
                } else {
                    setIsConfirm(true);
                    setOpenConfirm(true);
                }
            } else {
                setIsConfirm(false);
                setOpenConfirm(true);
            }
        } else {
            setActionTypeCode(null);
        }
    }

    const handleDenyRequest = () => {
        if (isDenyButtonEnabled) {
            if (isLeaveRequest) {
                if (storage.getIsRefusalRequestMandatoryComment()) {
                    if (!open) {
                        setOpenCommentForm(true);
                    } else {
                        if (!comment?.trim()) {
                            dispatch({ type: messagesTypes.CUSTOMERROR, payload: i18next.t('approvalCentral:message.refusalComent') });
                        } else {
                            updateDenyRequest();
                        }
                    }                    
                } else {
                    updateDenyRequest();
                }
            } else {
                if (isNullOrEmpty(messageConfirm)) {
                    updateDenyRequest();
                } else {
                    setIsConfirm(true);
                    setOpenConfirm(true);
                }
            }
        } else {
            setActionTypeCode(null);
        }
    }

    const handleRequest = (event, obj, action) => {

        const isLeaveRequest = getIsLeaveRequest(obj);
        const isDenyButtonEnabled = getIsDenyButtonEnabled(obj);
        const isApproveButtonEnabled = getIsApproveButtonEnabled(obj);

        switch (action) {
            case actionType.APPROVE:
                {
                    const approveMessage = getCentralApprovalCancellableStatusDescription(obj.cancellableCode, obj.statusCode, obj.applicantName, obj.creationDate, obj.description);
                    setMessageConfirm(approveMessage);
                    break;
                }
            case actionType.DENY:
                {
                    let denyMessage = '';
                    if (!isLeaveRequest &&
                        (isApproveButtonEnabled
                            || isDenyButtonEnabled)) {
                        if (obj.statusCode == centralApprovalStatus.CLOSE) {
                            denyMessage = format(i18next.t("approvalCentral:message.cancelation.cancelApprobationConfirmation"), obj.applicantName, i18next.t("approvalCentral:message.cancelation.approbationRequestConfirmationCreatedOn"), formatDate(obj.creationDate, 'date'));
                        } else {
                            denyMessage = format(i18next.t("approvalCentral:message.cancelation.denyApprobationConfirmation"), obj.applicantName, i18next.t("approvalCentral:message.cancelation.approbationRequestConfirmationCreatedOn"), formatDate(obj.creationDate, 'date'));
                        }
                    }

                    setMessageConfirm(denyMessage);
                    break;
                }
        }

        setDataRow(obj);
        setIsCancellable(getIsCancellable(obj));        
        setIsLeaveRequest(isLeaveRequest);
        setIsDenyButtonEnabled(isDenyButtonEnabled);
        setIsApproveButtonEnabled(isApproveButtonEnabled);
        setActionTypeCode(action);
    }

    const handleCloseConfirm = (closeDetail = true) => {

        setOpenConfirm(false);
        setIsPosting(false);

        if (closeDetail === true) {
            setOpen(false);
        }

        setActionTypeCode(null);
        setDataRow(null);
    }

    const getFirstDateOfMonth = (date) => {
        return new Date(date.getFullYear(), date.getMonth(), 1);
    }

    const setNextMonth = async () => {        
        const nextDate = getFirstDateOfMonth(new Date(date.setMonth(date.getMonth() + 1)));
        currentDateRef.current = nextDate;
        isFromNavigationBtnRef.current = true;
        setDate(nextDate);
        setMonth(nextDate.getMonth());
    }

    const setPreviousMonth = async () => {
        const previousDate = getFirstDateOfMonth(new Date(date.setMonth(date.getMonth() - 1)));
        currentDateRef.current = previousDate;
        isFromNavigationBtnRef.current = true;
        setDate(previousDate);
        setMonth(previousDate.getMonth());
    }

    const getInitials = (fullName) => {
        const initialTab = fullName.split(' ').map(part => part.charAt(0).toUpperCase());
        let initial = initialTab.join('');
        if (initialTab.length > 2) {
            initial = initialTab[0] + initialTab[initialTab.length - 1];
        }
        return initial;
    }

    const triggerChange = (newDate) => {

        const changeEvent = {
            target: calendarRef.current,
            value: newDate,
            syntheticEvent: {
                type: 'change'
            }
        };

        changeClick(changeEvent, true);
    };

    const changeClick = (e, focus = false) => {

        const currentDate = new Date((focus ? e.target.state.focusedDate : e.target.value).toLocaleDateString('en-US'));
        
        setTimeout(function () {
            currentDateRef.current = currentDate;                        
            setDate(currentDate);
            setMonth(currentDate.getMonth());
            setFilteredData(data?.filter(x => new Date(currentDate) >= new Date(x.startDate) && (new Date(currentDate) <= new Date(x.endDate) || x.endDate === null)));
        }, focus ? 100 : 0);
    }

    const handleClick = (obj) => {
        setDataRow(obj);
        setOpen(true);
    }

    const handleClose = () => {
        setDataRow(null);
        setOpen(false);
    };

    const CustomHeaderTitle = (props) => {

        let value = props.value || '';

        if (month != null
            && props.view === CalendarViewEnum.month) {

            const selectedMonth = monthNames.indexOf(value.split(' ')[0]);
            const selectedYear = value.split(' ')[1];

            if (month != null
                && selectedMonth != -1
                && selectedYear > 2000
                && (selectedMonth != month
                    || selectedYear != date.getFullYear())) {

                const newDate = new Date(selectedYear, selectedMonth, 1);
                
                if ((currentDateRef.current.toLocaleDateString('en-US') != date.toLocaleDateString('en-US'))
                    || (!isFromNavigationBtnRef.current
                        && currentDateRef.current.toLocaleDateString('en-US') != newDate.toLocaleDateString('en-US'))) {
                    triggerChange(newDate);
                }
            }
        } 

        return <CalendarHeaderTitle {...props}>
            {props.view === CalendarViewEnum.month ? `${value.split(' ')[0]}` : props.value}
            {props.view !== CalendarViewEnum.century ? <SvgIcon icon={svgIcons['arrowUpIcon']} size="small" /> : null}
        </CalendarHeaderTitle>;
    };

    const CellTemplate = (props) => {

        let className = '';
        const { value } = props;

        if (data?.filter(x => new Date(value) >= new Date(x.startDate) && (new Date(value) <= new Date(x.endDate) || x.endDate === null)).length > 0 ?? false) {
            className = 'primary';
        }

        return <CalendarCell {...props} className={className} />;
    };

    const DaySchedule = (props) => {

        let statusColor = '#ff7663';

        switch (props.data.state) {
            case absenceCalendarStatus.PENDING:
                statusColor = '#3a8bd8';
                break;
            case absenceCalendarStatus.APPROVED:
                statusColor = '#3ba96a';
                break;
        }

        const description = props.data.moduleDescription + (props.data.statusCode == centralApprovalStatus.CANCEL_REQUEST ? ' (' + getCentralApprovalStatusDescription(props.data.statusCode) + ')' : '');

        return (
            <div className={styles.daySchedule} onClick={props.onClick}>
                <div className={styles.entry}>
                    <div className={styles.avatar} style={{ backgroundColor: statusColor }}>{getInitials(props.data.employeeFullName)}</div>
                    <div className={styles.details}>
                        <strong
                            style={{
                                fontSize: '16px',
                                fontFamily: 'Arial, sans-serif'
                            }}
                        >{props.data.employeeFullName}</strong>
                        <p
                            style={{
                                fontSize: '12px',
                                marginTop: '0px'
                            }}
                        >{description}</p>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div
            id="divListRequest"
            style={{
                maxWidth: '800px',
                justifySelf: 'center',
                width: '100%',
                display: 'inline-block',
                minWidth: 280,
                width:'100%'
            }}
        >
            <div className={classes.selectMonth} >
                <IconButton size="small" aria-label="close" color="inherit" className={classes.refreshButton} onClick={refreshCalendar}>
                    <FontAwesomeIcon icon={faArrowsRotate} />
                </IconButton>
                <IconButton size="small" aria-label="close" color="inherit" onClick={setPreviousMonth}>
                    <ArrowBackIosIcon fontSize="small" />
                </IconButton>
                <div
                    style={{                        
                        display: 'inline-block',
                        minWidth: 178
                    }}
                >
                    <IconButton size="small" aria-label="close" color="inherit">
                        {capitalizeFirstLetter(getMonth(date, IsEnglish()))} {date.getFullYear()}
                    </IconButton>
                </div>
                <IconButton size="small" aria-label="close" color="inherit" onClick={setNextMonth}>
                    <ArrowForwardIosIcon fontSize="small" />
                </IconButton>
                <IconButton size="small" aria-label="close" color="inherit" className={classes.refreshButton} onClick={refreshCalendar}>
                    <FontAwesomeIcon icon={faArrowsRotate} />
                </IconButton>
            </div>            
            <div
                className="calendarStyle"
                style={{
                    maxWidth: 320,
                    margin:'auto'
                }}
            >
                <LocalizationProvider language={locale}>
                    <IntlProvider locale={locale}>

                        <div id="requestCalendar" className={styles.daySchedule} >
                            <Calendar
                                ref={calendarRef}
                                navigation={false}
                                value={date}
                                onChange={changeClick}
                                headerTitle={CustomHeaderTitle}
                                cell={CellTemplate}
                            />
                        </div>

                        <div id="requestHeader" className={styles.daySchedule} >
                            <h3
                                style={{
                                    textAlign: 'left',
                                    fontSize: '18px',
                                    fontWeight: 'bold'
                                }}
                            >{getDayAbbrUpper(date, IsEnglish())} {date.getDate()} {getMonthAbbrUpper(date, IsEnglish())}</h3>
                        </div>
                        {isActive && <FontAwesomeIcon icon={faLoader} style={{ fontSize: "55px" }} spin />}
                        <div id="requestDetail">
                            {filteredData != null && filteredData.map((obj, index) =>
                                <DaySchedule key={index} data={obj} onClick={() => handleClick(obj)}/>
                            )}
                        </div>
                        <div id="divLegend" className={classes.divLegend}>
                            <LegendTypeDay />
                        </div>
                    </IntlProvider>
                </LocalizationProvider>
            </div>

            {dataRow != null && <RequestDetail pageSource={pageSourceCode.CALENDAR}
                open={open}
                data={dataRow}
                comment={comment}
                setComment={setComment}
                load={refreshCalendar}
                isPosting={isPosting}
                setIsPosting={setIsPosting}
                onClose={handleClose}
                handleRequest={handleRequest}
                getIsLeaveRequest={getIsLeaveRequest}
                getIsActionButtonShown={getIsActionButtonShown}
                getIsDenyButtonEnabled={getIsDenyButtonEnabled}
                getIsApproveButtonEnabled={getIsApproveButtonEnabled}
            />}

            {openScheduleGeneration && <ScheduleGenerationForm open={openScheduleGeneration} setOpen={setOpenScheduleGeneration} employeeCode={dataRow.employeeCode} startDate={dataRow.startDate} endDate={dataRow.endDate} load={loadData} />}

            <Dialog
                open={openConfirm}
                onClose={handleCloseConfirm}
                aria-labelledby="draggable-dialog-title"
            >
                <DialogTitle id="draggable-dialog-title">
                    {!isConfirm ? i18next.t('approvalCentral:dialog.attention') : i18next.t('approvalCentral:dialog.title')}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {messageConfirm}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    {isConfirm && dataRow?.centralApprovalId > 0 &&
                        <Button autoFocus onClick={updateAction} color="primary" className={styles.defaultButton} variant="contained">
                            {i18next.t('buttons:yes')}
                        </Button>}
                    {isConfirm && dataRow?.centralApprovalId > 0 &&
                        <Button onClick={handleCloseConfirm} color="primary" className={styles.defaultButton} variant="contained">
                            {i18next.t('buttons:no')}
                        </Button>}
                    {!isConfirm && <Button onClick={handleCloseConfirm} color="primary" className={styles.defaultButton} variant="contained">
                        {i18next.t('buttons:close')}
                    </Button>}
                </DialogActions>
            </Dialog>

        </div>
    );
};


export default withNamespaces(['approvalCentral', 'common', 'buttons', 'error'], { wait: true })(CalendarItems);

CalendarItems.propTypes = {
    filter: PropTypes.object.isRequired
}